import React, { useContext } from "react";
import TableRow from "@mui/material/TableRow";
import Status from "../../../../shared/components/Status";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { MaterialOrder } from "../../../../data/entities";
import { MATERIAL_ORDER_STATUS, ROLE } from "../../../../data/enums";
import { MaterialOrderFilterType, valueToText } from "../../../../configs/filterTypes";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { formatCurrency } from "../../../../utils/format";
import { formatDateVi } from "../../../../utils/dateUtils";


export const getStatusColorTheme = (status: string) => {
    switch (status) {
        case MATERIAL_ORDER_STATUS.OPEN:
            return "INFO";
        case MATERIAL_ORDER_STATUS.IMPORTING:
            return "INFO";
        case MATERIAL_ORDER_STATUS.RESTOCK:
            return "SUCCESS";
        case MATERIAL_ORDER_STATUS.CANCELLED:
            return "FAIL";
        default:
            return "INFO";
    }
};

export const MaterialOrderRow = ({ item }: { item: MaterialOrder }) => {
    const { user: { role } } = useContext(AuthenticationContext);

    const isShowPrice = ![ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role);
    const providerName = item.provider_name || "N/A";
    const providerCell = item.provider_id ? (
        <StyledNavLink to={`/providers/${item.provider_id}`}>{providerName}</StyledNavLink>
    ) : (
        providerName
    );

    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLink to={`/material-orders/${item.id}`}>{item.name ? item.name : item.id}</StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">{providerCell}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getStatusColorTheme(item.status)}
                    text={valueToText(MaterialOrderFilterType, "status", item.status)}
                    width="124px"
                />
            </StyledTableCell>
            <StyledTableCell align="left">{formatDateVi(new Date(item.due_date))}</StyledTableCell>
            {
                isShowPrice && (
                    <StyledTableCell align="left">{formatCurrency(item.total_price)}</StyledTableCell>
                )
            }
            {/*<StyledTableCell align="left">*/}
            {/*    <Avatar sx={{ width: "24px", height: "24px" }} />*/}
            {/*</StyledTableCell>*/}
        </TableRow>
    );
};
